import React from "react";
import LoginForm from "./common/LoginForm";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Checkbox,
  CheckboxVisibility,
  Button,
  ButtonType,
  DatePicker,
  Dropdown,
  PrimaryButton,
} from "office-ui-fabric-react";
import { browserHistory } from "react-router";

import imgCity from "./imgs/city.jpg";
import imgLogo from "./imgs/login-logo.png";
import axios from "axios";
import config from "../config";
import InfiniteScroll from "react-infinite-scroller";
import StatusBar from "./common/StatusBar";
import moment from "moment";
import _ from "lodash";

export class Approve extends React.Component {
  constructor(props) {
    super(props);
    this.limit = 100;
    this.changedItems = [];
    this.state = {
      isLoading: false,
      isUpdating: false,
      hasMore: true,
      customers: [],
      searchText: "",
      total: 0,
      isSaving: false,
      startDate: "",
      endDate: "",
      approvalFilter: "pending",
    };
  }

  componentDidMount() {
    this.fetch();
  }

  componentWillReceiveProps(newPops) {
    this.setState({
      customers: [],
      hasMore: true,
    });
    this.fetch(newPops.searchBox, 0);
  }

  fetch(text, skip) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    axios
      .get(`${config.apiUrl}/customer/list`, {
        params: {
          limit: this.limit,
          skip: skip != undefined ? skip : this.state.customers.length,
          pa: 1,
          approval: this.state.approvalFilter,
          q:
            text == undefined || text == null
              ? this.props.searchBox.text || ""
              : text.text,
          approvalStartDate: this.state.startDate,
          approvalEndDate: this.state.endDate,
        },
      })
      .then(({ data }) => {
        var newCustomers = data
          .filter((e) => !this.state.customers.find((c) => c._id == e._id))
          .map((e) => {
            e.patientAssignmentApproval = e.patientAssignmentApproval || false;
            return e;
          });
        var customers = this.state.customers.concat(newCustomers);
        this.setState({
          customers: customers,
          isLoading: false,
          hasMore: newCustomers.length >= this.limit,
        });
      })
      .catch((ex) => {
        this.setState({
          isLoading: false,
        });
        // alert('Server error');
      });

    axios
      .get(`${config.apiUrl}/customer/count`, {
        params: {
          pa: 1,
          q:
            text == undefined || text == null
              ? this.props.searchBox.text || ""
              : text.text,
        },
      })
      .then(({ data }) => {
        this.setState({
          total: data.total,
        });
      })
      .catch((ex) => {});
  }

  // approveImmediately(e, v) {
  //   e.patientAssignmentApproval = v;
  //   e.patientAssignmentApprovalDate = new Date();
  //   this.setState({
  //     customers: [].concat(this.state.customers),
  //     isSaving: true
  //   });

  //   axios
  //   .post(`${config.apiUrl}/customer/update-approval`, [e])
  //   .then(({ data }) => {
  //     setTimeout(() => {
  //       this.setState({
  //         isSaving: false
  //       });
  //     }, 500);
  //   })
  //   .catch(ex => {
  //     console.error(ex);
  //     alert('Error');
  //   });
  // }

  approve(e, v) {
    e.patientAssignmentApproval = v;
    e.patientAssignmentApprovalDate = new Date();
    this.setState({
      customers: [].concat(this.state.customers),
    });

    if (!_.find(this.changedItems, (i) => i._id == e._id)) {
      this.changedItems.push(e);
    }
  }

  save() {
    this.setState({
      isSaving: true,
    });
    var data = this.changedItems.map((e) => ({
      _id: e._id,
      patientAssignmentApproval: e.patientAssignmentApproval,
    }));
    axios
      .post(`${config.apiUrl}/customer/update-approval`, data)
      .then(() => {
        setTimeout(() => {
          this.setState({
            isSaving: false,
          });
        }, 500);
        this.changedItems = [];
      })
      .catch((ex) => {
        console.log(ex);
        alert("Error");
      });
  }

  changeDate(key, date) {
    this.setState({
      [key]: date,
      customers: [],
      hasMore: true,
    });
    setTimeout(() => {
      this.fetch(this.props.searchBox, 0);
    }, 500);
  }

  changeFilter(value) {
    this.setState({
      approvalFilter: value.key,
      customers: [],
      hasMore: true,
      startDate:
        value.key == "all" || value.key == "pending"
          ? ""
          : this.state.startDate,
      endDate:
        value.key == "all" || value.key == "pending" ? "" : this.state.endDate,
    });

    setTimeout(() => {
      this.fetch(this.props.searchBox, 0);
    }, 500);
  }

  render() {
    // render HTML
    var approval = columns.find((e) => e.key == "approval");
    approval.onRender = (e) => {
      return (
        <div>
          <Checkbox
            checked={e.patientAssignmentApproval == "approval"}
            onChange={(elm, v) => this.approve(e, v ? "approval" : "")}
          />
        </div>
      );
    };
    var cancel = columns.find((e) => e.key == "cancel");
    cancel.onRender = (e) => {
      return (
        <div>
          <Checkbox
            checked={e.patientAssignmentApproval == "cancel"}
            onChange={(elm, v) => this.approve(e, v ? "cancel" : "")}
          />
        </div>
      );
    };

    const {
      isLoading,
      hasMore,
      customers,
      total,
      isSaving,
      startDate,
      endDate,
      approvalFilter,
    } = this.state;

    return (
      <div style={{ margin: 10 }}>
        <div className="ms-Grid" style={{ marginTop: 10 }}>
          <div className="ms-Grid-col ms-u-md2 one-line-200">
            <Dropdown
              selectedKey={approvalFilter}
              options={[
                { key: "all", text: "All" },
                { key: "pending", text: "Pending" },
                { key: "approval", text: "Approval" },
                { key: "cancel", text: "Cancel" },
              ]}
              onChanged={(v) => this.changeFilter(v)}
            />
          </div>
          <div className="ms-Grid-col ms-u-md3"></div>
          {approvalFilter != "pending" && (
            <div className="ms-Grid-col ms-u-md3">
              <DatePicker
                label="Start Date"
                className="one-line-100"
                formatDate={(date) => moment(date).format("MMM DD YYYY")}
                value={startDate ? new Date(startDate) : null}
                onSelectDate={(date) => this.changeDate("startDate", date)}
                allowTextInput
              />
            </div>
          )}
          {approvalFilter != "pending" && (
            <div className="ms-Grid-col ms-u-md3" style={{ marginLeft: 50 }}>
              <DatePicker
                label="End Date"
                className="one-line-100"
                formatDate={(date) => moment(date).format("MMM DD YYYY")}
                value={endDate ? new Date(endDate) : null}
                onSelectDate={(date) => this.changeDate("endDate", date)}
                allowTextInput
              />
            </div>
          )}
        </div>
        <InfiniteScroll
          pageStart={0}
          loadMore={() => this.fetch()}
          useWindow={true}
          initialLoad={false}
          style={{ marginBottom: 30 }}
          loader={isLoading && <Spinner key={1} size={SpinnerSize.large} />}
          hasMore={hasMore}
        >
          <DetailsList
            items={customers}
            columns={columns}
            checkboxVisibility={CheckboxVisibility.hidden}
            style={{ fontSize: 14 }}
          />
        </InfiniteScroll>
        <div
          style={{
            position: "fixed",
            bottom: 40,
            right: 10,
          }}
        >
          {
            <PrimaryButton onClick={() => this.save()}>
              {isSaving && <Spinner size={SpinnerSize.xSmall} />}
              {isSaving ? <span>&nbsp;&nbsp;Saving</span> : <span>Save</span>}
            </PrimaryButton>
          }
        </div>
        <StatusBar>
          <span>Total: {total}</span>
        </StatusBar>
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(Approve);

const labels = {
  "home-health": "Home Health",
  hospice: "Hospice",
  clinic: "Clinic",
  "sign-up": "Sign up",
};

const columns = [
  {
    key: "firstName",
    name: "First Name",
    fieldName: "firstName",
    minWidth: 200,
    maxWidth: 200,
  },
  {
    key: "lastName",
    name: "Last Name",
    fieldName: "lastName",
    minWidth: 200,
    maxWidth: 200,
  },
  {
    key: "phone",
    name: "Phone",
    fieldName: "phone",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    key: "patientAssignment",
    name: "Assigned To",
    fieldName: "patientAssignment",
    minWidth: 150,
    maxWidth: 150,
    onRender(item) {
      return labels[item.patientAssignment];
    },
  },
  {
    key: "patientAssignmentApprovalDate",
    name: "Approval Date",
    minWidth: 150,
    maxWidth: 150,
    onRender(item) {
      if (
        item.patientAssignmentApproval &&
        item.patientAssignmentApprovalDate
      ) {
        return moment(item.patientAssignmentApprovalDate).format("MMM DD YYYY");
      } else {
        return "";
      }
    },
  },
  {
    key: "approval",
    name: "Approval",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    key: "cancel",
    name: "Cancel",
    minWidth: 100,
    maxWidth: 100,
  },
];



// WEBPACK FOOTER //
// ./client/components/Approve.js